<template>
    <div>
        <stb-main>
            <stb-profile module="applicants"></stb-profile>
            <stb-notifications
                slot="sidebar"
                :title="$t('notifications')"
                :items="notifications"
                :showTimeline="true"
                :showTitle="me"
                @item-click="click_item"
           ></stb-notifications>
        </stb-main>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                me: false,
                notifications: null,

            };
        },
        mounted() {
            this.init();
            this.load();
        },
        methods: {
            init() {
                var id = this.$route.params.id;
                // is it my own account?
                var user = this.$api.user();
                if (this.$shared.user.profile && this.$shared.user.profile.objectId == id) {
                    this.me = true;
                }
            },
            load() {
                if (this.me) {
                    // load notifications
                    if (this.$shared.user.profile) {
                        var profile = this.$shared.user.profile.$p,
                            relation = profile.relation('notifications');
                        relation.query().find().then((notifications) => {
                            if (notifications) {
                                this.notifications = notifications.map((n) => {
                                    return {
                                        title: n.get('title'),
                                        subtitle: n.get('content'),
                                        link: n.get('link'),
                                        meta: this.convertDate(n.get('createdAt'))
                                    };
                                });
                            } else {
                                this.notifications = [];
                            }
                        });
                    }
                }
            },

            convertDate(date) {
                var date = new Date(date);
                var months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
                return date.getDate() + ". " + months[date.getMonth()] + " " + date.getFullYear();
            },
            click_item(item) {
                if (item && item.link) {
                    this.$router.push(item.link);
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/applicant.vue